import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import NonPatientActivityCreate from '../../features/NonPatientActivities/Create/NonPatientActivityCreate';
import globals from '../../globals/communityGlobals';
import { checkFeatureAccess } from '../../utils/helpers';
import { createNonPatientActivity } from '../../actions/entities';
import { dismissError } from '../../actions/entities/nonPatientActivities';

const mapStateToProps = ({ global: { auth }, entities: { nonPatientActivities } }) => {
  const access = auth.featureAccessList;
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canTriggerSync),
    failureMessage: nonPatientActivities.npaMessages.failure,
    isAssigning: nonPatientActivities.assigned.isAssigning,
  };
};

const mapDispatchToProps = dispatch => ({
  submitAction: async (NonPatientActivity, shouldAssignToday) =>
    await dispatch(createNonPatientActivity(NonPatientActivity, shouldAssignToday)),
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  dismissError: () => dispatch(dismissError()),
});

const NonPatientActivityCreateContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NonPatientActivityCreate);

export default NonPatientActivityCreateContainer;
